import { defineStore } from 'pinia';

const navigationStore = defineStore('navigationStore', {
    state: () => ({}),
    getters: {},
    actions: {}
});

export { navigationStore };
